<script setup lang="ts">
import { useHead } from '@unhead/vue'

const { t } = useI18n()

useHead({
  link: [{
    rel: 'canonical',
    href: `${import.meta.env.VITE_MONOLITH_URL}`,
  }],
})

useSeoMeta({
  title: t('home.meta.title'),
  description: t('home.meta.description'),
  ogTitle: t('home.meta.title'),
  ogDescription: t('home.meta.description'),
  ogImage: `${S3_ASSETS_URL}/meta-default.jpg`,
})
</script>

<template>
  <div class="isolate">
    <LayoutNavbar />
    <HomeHero />

    <HomeFeatures />
    <HomeSuccessStories />

    <div
      class="mb-8 bg-gradient-to-b from-[#F1F1DF] from-50% to-white shadow-2xl shadow-black/10 lg:mb-16 lg:rounded-b-[5rem]"
    >
      <HomeDashboardPreview />
      <HomeVideoTestimonials />
      <HomeTextTestimonials />

      <section class="mx-auto max-w-screen-xl lg:px-8 lg:pb-16">
        <div class="relative overflow-clip px-4 py-10 md:px-8 md:py-20 lg:rounded-3xl">
          <div class="absolute inset-0 isolate before:absolute before:inset-0 before:z-[1] before:bg-gray-800/70">
            <img
              :src="`${S3_ASSETS_URL}/home/cta-02.jpg`"
              class="aspect-video size-full object-cover object-center"
              role="presentation"
            >
          </div>

          <div class="isolate grid place-items-center gap-5">
            <h3 class="max-w-screen-sm text-balance text-center text-3xl leading-tight text-white lg:text-5xl">
              {{ t('home.cta_banner.title') }}
            </h3>

            <UiButton
              class="group w-full max-w-xs lg:max-w-max"
              as-child
            >
              <RouterLink :to="{ name: '/free-demo' }">
                {{ t('home.cta_banner.action') }}

                <UiIcon
                  name="arrow-forward-rounded"
                  class="transition-transform duration-200 group-hover:translate-x-1"
                />
              </RouterLink>
            </UiButton>
          </div>
        </div>
      </section>
    </div>

    <LayoutFooter />
  </div>
</template>
